import 'bootstrap/js/tooltip';

const discussionView = require('templates/discussion.jst.jade')

export default class DiscussionItem {
  static new(resource, currentUsername, options = {}) {
    this.ui = {
      item:         '.livestreaming-discussion__item',
      avatar:       '.livestreaming-discussion-item__avatar',
      initial:      '.livestreaming-discussion-item__initial',
      avatarImage:  '.livestreaming-discussion-item__avatar-image',
      name:         '.livestreaming-discussion-item__username',
      verified:     '.verified-user',
      timestamp:    '.livestreaming-discussion-item__timestamp',
      content:      '.livestreaming-discussion-item__content'
    };

    this.resource = resource;
    this.currentUsername = currentUsername;
    this.canRemoveChat = (options.canRemoveChat == true);
    this.isVirtualGift = resource.type === 'chat/gift';
    this.html = '';

    this.render();

    this.reattachRelativeTime();
    this.reattachVerifiedTooltip();

    return this;
  }

  static render(){
    this.html = $(discussionView({ comment: this.resource, canRemoveChat: this.canRemoveChat, isVirtualGift: this.isVirtualGift, formatPrice: this.formatPrice }));
  }

  static formatPrice(value){
    var formatted = new Intl.NumberFormat('id-ID').format(value);
    return formatted.replace(/\,/g, '.');
  }

  static reattachRelativeTime(){
    var timestamp = this.html.find(this.ui.timestamp);
    var concatDate = new Date(timestamp.attr('title'));
    var addZero = function(number){
      if(number < 10){
        return "0" + number;
      }
      return number;
    };

    timestamp.html(addZero(concatDate.getHours()) + ":" + addZero(concatDate.getMinutes()));
  }

  static reattachVerifiedTooltip(){
    this.html.find(this.ui.verified).tooltip();
  }

  static reattachCurrentCommenter() {
    if (this.resource.user.username === this.currentUsername) {
      this.html.addClass('livestreaming-discussion-item__current-comment-' + this.resource.id);
    }
  }

  static destroy(){
    this.html.remove();
  }
}
